import { Flex, theme, Typography } from 'antd'
import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate } from 'react-router-dom'
import { findActiveNavKey } from './navItems'
import { useVisibleNav } from './useVisibleNav'

/**
 * Pastki tab-bar — telefonda ASOSIY navigatsiya.
 *
 * ⚠️ ADR-030 §4: kassa ekrani «noldan, TELEFONGA MO'LJALLAB» yoziladi,
 * chunki kassirning asosiy qurilmasi telefon. Doimiy yon ustun yoki
 * yuqoridagi menyu barmoq eng qiyin yetadigan joyda bo'lardi; pastki
 * qator esa bosh barmoq harakati bilan bir xil.
 *
 * ⚠️ RO'YXAT TO'RTTADAN OSHMASIN (`navItems.tsx` izohi) — beshtadan
 * ortiq element tugmalarni 44px dan toraytiradi. Shuning uchun bu yerda
 * FAQAT `nav.primary` chiziladi: jurnallar (`nav.secondary`) telefonda
 * hisob menyusiga tushadi, tab-bar esa 2026-08-20 dagi kompyuter
 * o'zgarishlaridan keyin ham AYNAN o'sha to'rt banddan iborat qoladi.
 */
export function MobileTabBar() {
  const { t } = useTranslation()
  const { token } = theme.useToken()
  const location = useLocation()
  const navigate = useNavigate()
  const nav = useVisibleNav()
  const activeKey = findActiveNavKey(location.pathname)

  return (
    <nav
      className="xsib-tabbar"
      style={{
        background: token.colorBgContainer,
        borderTop: `1px solid ${token.colorBorderSecondary}`,
      }}
    >
      <Flex justify="space-around" align="center" style={{ height: 64 }}>
        {nav.primary.map((item) => {
          const active = item.key === activeKey
          return (
            <button
              key={item.key}
              type="button"
              onClick={() => navigate(item.path)}
              aria-current={active ? 'page' : undefined}
              style={{
                background: 'none',
                border: 'none',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: 2,
                padding: '6px 8px',
                minWidth: 56,
                color: active ? token.colorPrimary : token.colorTextSecondary,
                cursor: 'pointer',
              }}
            >
              <span style={{ fontSize: 20 }}>{item.icon}</span>
              <Typography.Text style={{ fontSize: 11, color: 'inherit' }}>
                {t(item.labelKey)}
              </Typography.Text>
            </button>
          )
        })}
      </Flex>
    </nav>
  )
}
